module.exports = __webpack_public_path__ + "static/media/kraken_logo.617a4f00.svg";